/**
 * glør Popups (sections/glr-popups.liquid).
 * Klick auf einen Link mit "#glr-popup-<name>" -> Inhalt der Section, deren ID
 * <name> enthaelt, als Kopie in einen <dialog>. Keine Aenderung an Horizon.
 */
(() => {
  const dlg = document.querySelector('[data-glr-popup]');
  if (!dlg) return;
  // Die Section selbst ist unsichtbar (display:none) - der Dialog muss raus,
  // sonst wird er nicht gezeichnet.
  document.body.appendChild(dlg);
  const body = dlg.querySelector('[data-glr-popup-body]');
  const PREFIX = '#glr-popup-';

  function source(name) {
    const sel = `main .shopify-section[id*="__${CSS.escape(name)}"]`;
    return document.querySelector(sel);
  }

  function open(name, trigger) {
    const src = source(name);
    if (!src) return false;
    const clone = src.cloneNode(true);
    clone.removeAttribute('id');
    clone.style.display = 'block';
    clone.querySelectorAll('[id]').forEach((n) => n.removeAttribute('id'));
    clone.querySelectorAll('img[loading="lazy"]').forEach((i) => i.setAttribute('loading', 'eager'));
    body.replaceChildren(clone);
    wirePicks(clone);
    const label = trigger?.closest('.group-block')?.textContent?.trim() || trigger?.textContent?.trim();
    if (label) dlg.setAttribute('aria-label', label.slice(0, 120));
    dlg.showModal();
    document.body.classList.add('glr-popup-open');
    // Videos in der Kopie starten (die Lazy-Logik der Section haengt am Original)
    clone.querySelectorAll('video').forEach((v) => {
      if (v.offsetParent === null) return;
      v.querySelectorAll('source[data-src]').forEach((s) => s.setAttribute('src', s.getAttribute('data-src')));
      if (v.dataset.src && !v.getAttribute('src')) v.setAttribute('src', v.dataset.src);
      v.muted = true; v.loop = true; v.playsInline = true;
      v.classList.add('is-on', 'is-playing');
      v.load();
      const p = v.play(); if (p && p.catch) p.catch(() => {});
    });
    return true;
  }

  // Karten im Popup (z. B. Groessenvergleich) waehlen die passende Variante:
  // Karte enthaelt den Titel einer Groessen-Karte der Seite (laengster Treffer gewinnt).
  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
  function wirePicks(root) {
    const opts = [...document.querySelectorAll('[data-glr-vq-opt]')].filter((b) => !dlg.contains(b));
    if (!opts.length) return;
    root.querySelectorAll('.glr-compare__card, [data-glr-popup-select]').forEach((card) => {
      const txt = norm(card.textContent);
      let best = null; let len = 0;
      opts.forEach((b) => {
        const t = norm(b.querySelector('.glr-vq__card-title')?.textContent || b.dataset.optionValue);
        if (t && txt.includes(t) && t.length > len) { best = b; len = t.length; }
      });
      if (!best) return;
      card.setAttribute('data-glr-popup-pick', '');
      card.setAttribute('role', 'button');
      card.setAttribute('tabindex', '0');
      if (best.getAttribute('aria-checked') === 'true') card.classList.add('is-current');
      const pick = () => { best.click(); close(); };
      card.addEventListener('click', pick);
      card.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); } });
    });
  }

  // "So funktioniert's" hinter USP-Zeilen, deren Gruppen-Link ein Popup ist
  function addMoreLinks() {
    const label = dlg.dataset.more;
    if (!label) return;
    document.querySelectorAll('.group-block__link[href*="' + PREFIX + '"]').forEach((link) => {
      const group = link.closest('.group-block') || link.parentElement;
      if (!group || group.querySelector('.glr-popup-more')) return;
      const ps = group.querySelectorAll('.text-block p, p');
      const p = ps[ps.length - 1];
      if (!p) return;
      const a = document.createElement('a');
      a.className = 'glr-popup-more';
      a.href = link.getAttribute('href');
      a.textContent = label;
      p.append(' – ', a);
    });
  }

  function close() {
    if (dlg.open) dlg.close();
  }

  dlg.addEventListener('close', () => {
    document.body.classList.remove('glr-popup-open');
    body.replaceChildren();
  });
  dlg.addEventListener('click', (e) => {
    if (e.target === dlg || e.target.closest('[data-glr-popup-close]')) close();
  });

  addMoreLinks();
  new MutationObserver(addMoreLinks).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href*="' + PREFIX + '"]');
    if (!a || a.classList.contains('group-block__link')) return;
    const name = decodeURIComponent(a.getAttribute('href').split(PREFIX)[1] || '').trim();
    if (!name) return;
    if (open(name, a)) e.preventDefault();
  });
})();
